var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptySearchResult = function SvgImgEmptySearchResult(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_2648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 15H14C11.2386 15 9 17.2386 9 20V58C9 60.7614 11.2386 63 14 63H66C68.7614 63 71 60.7614 71 58V20C71 17.2386 68.7614 15 66 15Z",
    fill: "white",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 22.5H70.5",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 19L67 19",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 46,
    r: 10,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4701 45.854C50.4701 43.7541 49.8474 41.7014 48.6808 39.9554C47.5142 38.2094 45.856 36.8486 43.916 36.045C41.976 35.2414 39.8412 35.0312 37.7817 35.4408C35.7222 35.8505 33.8304 36.8617 32.3455 38.3465C30.8607 39.8313 29.8495 41.7231 29.4398 43.7827C29.0302 45.8422 29.2404 47.9769 30.044 49.917C30.8476 51.857 32.2084 53.5152 33.9544 54.6818C35.7004 55.8484 37.7531 56.4711 39.853 56.4711C42.6678 56.4679 45.3665 55.3483 47.3569 53.3579C49.3473 51.3675 50.4669 48.6688 50.4701 45.854ZM30.3534 45.854C30.3534 43.9751 30.9106 42.1385 31.9544 40.5763C32.9982 39.0141 34.4818 37.7965 36.2177 37.0775C37.9535 36.3585 39.8635 36.1704 41.7062 36.5369C43.549 36.9035 45.2416 37.8082 46.5702 39.1368C47.8987 40.4653 48.8034 42.158 49.17 44.0007C49.5365 45.8434 49.3484 47.7535 48.6294 49.4893C47.9104 51.2251 46.6928 52.7087 45.1306 53.7525C43.5685 54.7964 41.7318 55.3535 39.853 55.3535C37.3344 55.3507 34.9198 54.3489 33.1389 52.568C31.358 50.7871 30.3562 48.3725 30.3534 45.854Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.752 60.9236H42.9528V68.2248C42.9528 69.3294 42.0574 70.2248 40.9528 70.2248H38.752C37.6474 70.2248 36.752 69.3294 36.752 68.2248V60.9236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.752 60.9236H42.9528V68.2248C42.9528 69.3294 42.0574 70.2248 40.9528 70.2248H38.752C37.6474 70.2248 36.752 69.3294 36.752 68.2248V60.9236Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2051 59.8243H42.6463V58.3973C45.7359 57.7092 48.4629 55.9051 50.3048 53.3309C52.1466 50.7566 52.9737 47.5932 52.6276 44.4469C52.2815 41.3006 50.7864 38.3926 48.429 36.2804C46.0716 34.1681 43.0177 33 39.8523 33C36.687 33 33.6331 34.1681 31.2757 36.2804C28.9183 38.3926 27.4232 41.3006 27.0771 44.4469C26.731 47.5932 27.5581 50.7566 29.3999 53.3309C31.2417 55.9051 33.9688 57.7092 37.0584 58.3973V59.8243H36.4996C36.3514 59.8243 36.2092 59.8832 36.1044 59.988C35.9996 60.0928 35.9408 60.2349 35.9408 60.3831V67.0887C35.9408 68.1261 36.3529 69.121 37.0864 69.8546C37.82 70.5881 38.8149 71.0003 39.8523 71.0003C40.8898 71.0003 41.8847 70.5881 42.6183 69.8546C43.3518 69.121 43.7639 68.1261 43.7639 67.0887V60.3831C43.7639 60.2349 43.7051 60.0928 43.6003 59.988C43.4955 59.8832 43.3533 59.8243 43.2051 59.8243ZM28.1176 45.8544C28.116 43.5331 28.8028 41.2635 30.0912 39.3327C31.3796 37.4018 33.2117 35.8964 35.3558 35.0069C37.4999 34.1175 39.8596 33.8839 42.1365 34.3357C44.4134 34.7875 46.5051 35.9045 48.1471 37.5453C49.789 39.1861 50.9075 41.277 51.361 43.5535C51.8144 45.8301 51.5826 48.19 50.6946 50.3347C49.8067 52.4794 48.3026 54.3127 46.3727 55.6025C44.4427 56.8923 42.1736 57.5807 39.8523 57.5807C36.7427 57.5772 33.7612 56.3409 31.5615 54.1428C29.3618 51.9447 28.1234 48.9641 28.1176 45.8544ZM41.5287 58.5976V59.8243H38.176V58.5976C38.7321 58.6674 39.2919 58.7038 39.8523 58.7067C40.4128 58.7026 40.9725 58.6662 41.5287 58.5976ZM42.6463 67.0887C42.6463 67.8297 42.352 68.5404 41.828 69.0643C41.304 69.5883 40.5934 69.8827 39.8523 69.8827C39.1113 69.8827 38.4007 69.5883 37.8767 69.0643C37.3527 68.5404 37.0584 67.8297 37.0584 67.0887V60.9419H42.6463V67.0887Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 19,
    r: 1.5,
    stroke: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.2002,
    cy: 19,
    r: 1.5,
    stroke: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.4004,
    cy: 19,
    r: 1.5,
    stroke: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_2648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptySearchResult);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img_empty_search_result.a8b70ffd2f82470779d22ae5d5ec33a4.svg";